import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';
import { newTagInChapterModalSlice, NewTagInChapterModalDispatchParams, NewTagInChapterModalState } from '@REDUCERS';

function createNewTagInChapterModalHook() {
    return function useNewTagInChapterModal(equalityFn?: EqualityFn<NewTagInChapterModalState>) {
        const state = useAppSelector((store) => store.newTagInChapterModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: NewTagInChapterModalDispatchParams) => dispatch(newTagInChapterModalSlice.actions.open(params)),
            close: () => dispatch(newTagInChapterModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createNewTagInChapterModalHook();
